import type { AdConfig, AdPlacementConfig, PlacementName } from 'interfaces/ads/Ad';

export default class AdLibrary {
  private static instance: AdLibrary;

  private config!: AdConfig;

  private initialized: boolean;

  static getInstance(): AdLibrary {
    if (!AdLibrary.instance) {
      AdLibrary.instance = new AdLibrary();
    }

    return AdLibrary.instance;
  }

  private constructor() {
    this.initialized = false;
  }

  async init(config: AdConfig) {
    if (this.initialized) {
      return;
    }
    this.initialized = true;
    this.config = config;
  }

  getPlacementConfig = (placementName: PlacementName): AdPlacementConfig => {
    const config = this.config.placements.find((placementConfig) => placementConfig.name === placementName);

    if (!config) {
      throw new Error(`Placement ${placementName} is not configured!`);
    }
    return config;
  };
}
